export const SaveSkipFooter = ({
  text = '저장 후 다음',
  skipText = '돌아가기',
  handleClick,
  handleSkip,
  isValid,
  btnStyle = 'gradient-btm',
  buttonStyle = 'btm-btn-primary',
  textStyle = "btn-txt-01",
  ...props
}) => {
  return (
    <div className={`btm-area ${btnStyle}`} {...props}>
      <button className={`btn ${buttonStyle}`} onClick={handleClick} type='submit' disabled={!isValid}>
        <span className={`${textStyle}`}>{text}</span>
      </button>
      <div className='skip-wrap'>
        <button type='button' className='skip-btn' onClick={handleSkip}>
          {skipText}
        </button>
      </div>
    </div>

  );
};

export default SaveSkipFooter